import Footer from "./Component/Footer";
import Home from "./Home";
import Sponsors from "./Sponsors";
import SeaTurtleFacts from "./SeaTurtleFacts";
import { Router, Switch, Route } from "react-router-dom";
import { createBrowserHistory } from "history";
import Contact from "./Contact";
import HawksbillProject from "./HawksbillProject";
import FoundationNews from "./FoundationNews";
import Education from "./Education";
import WaterwayCleanup from "./FoundationNews/WaterwayCleanup";
import FloridaSeaTurtlesGetaBoost from "./FoundationNews/FloridaSeaTurtlesGetaBoost";
import SargassumBloomsandHatchlingProduction from "./FoundationNews/SargassumBloomsandHatchlingProduction";
import Conservation from "./Conservation";
import AReelDilemma from "./FoundationNews/AReelDilemma";
import memoryofLlewellynEhrhart from "./FoundationNews/memoryofLlewellynEhrhart";
import NewAluminumNestMarkingSigns from "./FoundationNews/NewAluminumNestMarkingSigns";
import StatewideNestingSummary2018 from "./FoundationNews/StatewideNestingSummary2018";
import Link from '@mui/material/Link';
import SeaTurtleAdventures from "./FoundationNews/SeaTurtleAdventures";
import EducationatFIUCenterOceans from "./FoundationNews/EducationatFIUCenterOceans";
import DaringExcitingToothy from "./FoundationNews/DaringExcitingToothy";
import ClassroomEducation from "./FoundationNews/ClassroomEducation";
import OutandAbout from "./FoundationNews/OutandAbout";
import SeaTurtleAdventures2021 from "./FoundationNews/SeaTurtleAdventures2021";
import SeaTurtleMonitoringandSatelliteTracking from "./FoundationNews/SeaTurtleMonitoringandSatelliteTracking";
import NavigatingtheFuture from "./FoundationNews/NavigatingtheFuture";
import SupportsEducation from "./FoundationNews/SupportsEducation";
import WhatAreYouDoing from "./FoundationNews/WhatAreYouDoing";
import MaleGreenTurtles from "./FoundationNews/MaleGreenTurtles";
import LeatherbackNesting from "./FoundationNews/LeatherbackNesting";
import SaltyAirSea from "./FoundationNews/SaltyAirSea";
import SandyPoint from "./FoundationNews/SandyPoint";
import LearningLeatherbacks from "./FoundationNews/LearningLeatherbacks";
import FAUsecondYear from "./FoundationNews/FAUsecondYear";
import NovaMember from "./FoundationNews/NovaMember";
import SupportFLgulf from "./FoundationNews/SupportFLgulf";
import GlobalSeaTurtle from "./FoundationNews/GlobalSeaTurtle";
import TrunksTravelSouth from "./FoundationNews/TrunksTravelSouth";
import InwaterResearch from "./FoundationNews/InwaterResearch";
import MEECadds from "./FoundationNews/MEECadds";
import UCFReceives from "./FoundationNews/UCFReceives";
import FinalReport2020 from "./FoundationNews/FinalReport2020";
import TemperatureInterview from "./FoundationNews/TemperatureInterview";
import MarineTurtleHistory from "./FoundationNews/MarineTurtleHistory";
import MikeSalmon from "./FoundationNews/MikeSalmon";
import RecipientsChosen from "./FoundationNews/RecipientsChosen";
import WhitneyLab from "./FoundationNews/WhitneyLab";
import IndianRiver from "./FoundationNews/IndianRiver";
import FAUlabRefreshed from "./FoundationNews/FAUlabRefreshed";
import FGCUawards from "./FoundationNews/FGCUawards";
import BlackSaltmarsh from "./FoundationNews/BlackSaltmarsh";
import DrErinSeney from "./FoundationNews/DrErinSeney";
import NewTurtleModel from "./FoundationNews/NewTurtleModel";
import UCFscholarshipAward from "./FoundationNews/UCFscholarshipAward";
import UVIpartnership from "./FoundationNews/UVIpartnership";
import FLHawkbill2020 from "./FoundationNews/FLHawkbill2020";
import InwaterJupiter from "./FoundationNews/InwaterJupiter";
import LeatherbackLight from "./FoundationNews/LeatherbackLight";
import SandyPoint2020 from "./FoundationNews/SandyPoint2020";
import MeetStudents from "./FoundationNews/MeetStudents";
import AmazingMantas from "./FoundationNews/AmazingMantas";
import CostalCleanup from "./FoundationNews/CostalCleanup";
import TurlteAdventureExpand from "./FoundationNews/TurlteAdventureExpand";
import InsightsKeewaydin from "./FoundationNews/InsightsKeewaydin";
import EastCoastBiologists from "./FoundationNews/EastCoastBiologists";
import WarmingOliveRidley from "./FoundationNews/WarmingOliveRidley";
import SargassoSea from "./FoundationNews/SargassoSea";
import InsightsKeewaydin2 from "./FoundationNews/InsightsKeewaydin2";
import EducationDuringCOVID from "./FoundationNews/EducationDuringCOVID";
import SargassumNowWorld from "./FoundationNews/SargassumNowWorld";
import StcroixProject from "./FoundationNews/StcroixProject";
import PHDstudents from "./FoundationNews/PHDstudents";
import HelpedBioAlum from "./FoundationNews/HelpedBioAlum";
import StyrofoamBoxes from "./FoundationNews/StyrofoamBoxes";
import BrowardCountryNesting from "./FoundationNews/BrowardCountryNesting";
import Hawksbill2021 from "./FoundationNews/Hawksbill2021";
import InsideTurtleNest from "./FoundationNews/InsideTurtleNest";
import InwaterTeachesPasco from "./FoundationNews/InwaterTeachesPasco";
import MORAESVkey from "./FoundationNews/MORAESVkey";
import UFwhitneyLab from "./FoundationNews/UFwhitneyLab";
import { motion } from "framer-motion";
import Differencesinvisualperception from "./Research/Differencesinvisualperception";
import UCFMarineTurtleResearchGroup from "./Research/UCFMarineTurtleResearchGroup";
import FloridaHawksbillProject2020 from "./Research/FloridaHawksbillProject2020";
import AMDRO from "./Research/AMDRO";
import IdentifyingSexinHatchlingTurtles from "./Research/IdentifyingSexinHatchlingTurtles";
import MigrationofLoggerheadHatchlings from "./Research/MigrationofLoggerheadHatchlings";
import AnimalBehaviorandVisualPerception from "./Research/AnimalBehaviorandVisualPerception";
import EpibiontsofHawksbill from "./Research/EpibiontsofHawksbill";
import StudyingFloridasLivingDinosaurs from "./Research/StudyingFloridasLivingDinosaurs";
import SatelliteTracking from './Research/SatelliteTracking';
import RecoveryatGumboLimbo from "./Research/RecoveryatGumboLimbo";
import StudySeaTurtlesinBiscayneNationalPark from "./Research/StudySeaTurtlesinBiscayneNationalPark";
import EvaluatingtheEffectsofPaternity from "./Research/EvaluatingtheEffectsofPaternity";
import CanMarineTurtlesNavigate from "./Research/CanMarineTurtlesNavigate";
import OctopusSuperpowers from "./Research/OctopusSuperpowers";
import SeekingTheGreenTurtles from "./Research/SeekingTheGreenTurtles";
import HawksbillTurtleAggregation from "./Research/HawksbillTurtleAggregation";
import Whysexingaseaturtlehatchlingisimportant from "./Research/Whysexingaseaturtlehatchlingisimportant";
import HawksbillProjectHighlightedinVideoProduction from "./Research/HawksbillProjectHighlightedinVideoProduction";
import Hawksbill from './SeaTurtles/Hawksbill'
import KempsRidley from "./SeaTurtles/KempsRidley";
import Loggerhead from './SeaTurtles/Loggerhead';
import Green from './SeaTurtles/Green';
import Leatherback from './SeaTurtles/Leatherback'
import LeatherbackSeaTurtleVision from "./FoundationNews/LeatherbackSeaTurtleVision";
import AdoptSeaTurtle from "./AdoptSeaTurtle";
import SocialMedia from "./Component/socialMedia";
import Navigation from './Component/Navigation';
import BecomeAMember from "./Membership/BecomeAMember";
import ScholarshipProgram from "./ScholarshipProgram";
import SeaTurtleBG from "./Component/SeaTurtleBG";
import CashDonation from "./CashDonation";
import "./App.css";
import { useLocation } from "react-router-dom";
import NotFoundPage from "./NotFoundPage";
import { HelmetProvider } from 'react-helmet-async';
import WeSupport from './WeSupport';


const history = createBrowserHistory();

function App() {

  const location = useLocation();

  return (
    <div className="Turtle-Font-Reg">
      <div>
        {location.pathname === "/" && <SeaTurtleBG />}

      </div>
      <div className={`relative z-10 justify-center`} >



        <div className="flex">
          <div className="flex-auto"><Navigation /></div>
        </div>

        <div>
          <HelmetProvider>
            <Router history={history}>
              <div>
                <motion.div
                  initial={{ x: "100%" }}
                  animate={{
                    x: "0%",
                    transition: { type: "easeInOut", duration: 0.4, frame: 120 },
                  }}
                  className="lg:mx-52 mx-8 my-20"
                >


                  <div>

                    <Link hidden href="/" />
                    <Link hidden href="/Education" />
                    <Link hidden href="/HawksbillProject" />
                    <Link hidden href="/Conservation" />
                    <Link hidden href="/FoundationNews" />

                    <Link hidden href="/FoundationNews/LeatherbackSeaTurtleVision" />
                    <Link hidden href="/FoundationNews/WaterwayCleanup" />


                    <Link hidden href="/FoundationNews/FloridaSeaTurtlesGetaBoost" />
                    <Link hidden href="/FoundationNews/SargassumBloomsandHatchlingProduction" />
                    <Link hidden href="/FoundationNews/AReelDilemma" />
                    <Link hidden href="/FoundationNews/memoryofLlewellynEhrhart" />
                    <Link hidden href="/FoundationNews/NewAluminumNestMarkingSigns" />
                    <Link hidden href="/FoundationNews/SeaTurtleMonitoringandSatelliteTracking" />
                    <Link hidden href="/FoundationNews/SeaTurtleAdventures2021" />
                    <Link hidden href="/FoundationNews/StatewideNestingSummary2018" />
                    <Link hidden href="/FoundationNews/SeaTurlteAdventures" />
                    <Link hidden href="/FoundationNews/EducationatFIUCenterOceans" />
                    <Link hidden href="/SeaTurtleFacts" />
                    <Link hidden href="/SeaTurtles/Hawksbill" />
                    <Link hidden href="/SeaTurtles/KempsRidley" />
                    <Link hidden href="/SeaTurtles/Loggerhead" />
                    <Link hidden href="/SeaTurtles/Green" />
                    <Link hidden href="/SeaTurtles/Leatherback" />

                    <Link hidden href="/Membership/BecomeAMember" />
                    <Link hidden href="/Membership/Member25" />
                    <Link hidden href="/Membership/Member25Friend" />
                    <Link hidden href="/Membership/Member50" />
                    <Link hidden href="/Membership/Member50Friend" />
                    <Link hidden href="/Membership/Member100" />
                    <Link hidden href="/Membership/Member100Friend" />
                    <Link hidden href="/Membership/Member300" />
                    <Link hidden href="/Membership/Member500" />
                    <Link hidden href="/Membership/Member500Friend" />
                    <Link hidden href="/Membership/Member1000" />
                    <Link hidden href="/Membership/Member1000Friend" />
                    <Link hidden href="/Membership/Member5000" />
                    <Link hidden href="/Membership/Member5000Friend" />

                    <Link hidden href="/ScholarshipProgram" />


                    <Link hidden href="/CashDonation" />

                    {/* <Link hidden href="/Component/HawksbillProjectForm" /> */}


                    <Link hidden href="/FoundationNews/DaringExcitingToothy" />
                    <Link hidden href="/FoundationNews/ClassroomEducation" />
                    <Link hidden href="/FoundationNews/OutandAbout" />
                    <Link hidden href="/FoundationNews/NavigatingtheFuture" />
                    <Link hidden href="/FoundationNews/SupportsEducation" />
                    <Link hidden href="/FoundationNews/WhatAreYouDoing" />
                    <Link hidden href="/FoundationNews/MaleGreenTurtles" />
                    <Link hidden href="/FoundationNews/LeatherbackNesting" />
                    <Link hidden href="/FoundationNews/SaltyAirSea" />
                    <Link hidden href="/FoundationNews/SandyPoint" />
                    <Link hidden href="/FoundationNews/LearningLeatherbacks" />
                    <Link hidden href="/FoundationNews/FAUsecondYear" />
                    <Link hidden href="/FoundationNews/NovaMember" />
                    <Link hidden href="/FoundationNews/SupportFLgulf" />
                    <Link hidden href="/FoundationNews/GlobalSeaTurtle" />
                    <Link hidden href="/FoundationNews/TrunksTravelSouth" />
                    <Link hidden href="/FoundationNews/InwaterResearch" />
                    <Link hidden href="/FoundationNews/MEECadds" />
                    <Link hidden href="/FoundationNews/UCFReceives" />
                    <Link hidden href="/FoundationNews/FinalReport2020" />
                    <Link hidden href="/FoundationNews/TemperatureInterview" />
                    <Link hidden href="/FoundationNews/MarineTurtleHistory" />
                    <Link hidden href="/FoundationNews/MikeSalmon" />
                    <Link hidden href="/FoundationNews/RecipientsChosen" />
                    <Link hidden href="/FoundationNews/WhitneyLab" />
                    <Link hidden href="/FoundationNews/IndianRiver" />
                    <Link hidden href="/FoundationNews/FAUlabRefreshed" />
                    <Link hidden href="/FoundationNews/FGCUawards" />
                    <Link hidden href="/FoundationNews/BlackSaltmarsh" />
                    <Link hidden href="/FoundationNews/DrErinSeney" />
                    <Link hidden href="/FoundationNews/NewTurtleModel" />
                    <Link hidden href="/FoundationNews/UCFscholarshipAward" />
                    <Link hidden href="/FoundationNews/UVIpartnership" />
                    <Link hidden href="/FoundationNews/FLHawkbill2020" />
                    <Link hidden href="/FoundationNews/InwaterJupiter" />
                    <Link hidden href="/FoundationNews/LeatherbackLight" />
                    <Link hidden href="/FoundationNews/SandyPoint2020" />
                    <Link hidden href="/FoundationNews/MeetStudents" />
                    <Link hidden href="/FoundationNews/AmazingMantas" />
                    <Link hidden href="/FoundationNews/CostalCleanup" />
                    <Link hidden href="/FoundationNews/TurlteAdventureExpand" />
                    <Link hidden href="/FoundationNews/InsightsKeewaydin" />
                    <Link hidden href="/FoundationNews/EastCoastBiologists" />
                    <Link hidden href="/FoundationNews/WarmingOliveRidley" />
                    <Link hidden href="/FoundationNews/SargassoSea" />
                    <Link hidden href="/FoundationNews/InsightsKeewaydin2" />
                    <Link hidden href="/FoundationNews/EducationDuringCOVID" />
                    <Link hidden href="/FoundationNews/SargassumNowWorld" />
                    <Link hidden href="/FoundationNews/StcroixProject" />
                    <Link hidden href="/FoundationNews/PHDstudents" />
                    <Link hidden href="/FoundationNews/HelpedBioAlum" />
                    <Link hidden href="/FoundationNews/StyrofoamBoxes" />
                    <Link hidden href="/FoundationNews/BrowardCountryNesting" />
                    <Link hidden href="/FoundationNews/Hawksbill2021" />
                    <Link hidden href="/FoundationNews/InsideTurtleNest" />
                    <Link hidden href="/FoundationNews/InwaterTeachesPasco" />
                    <Link hidden href="/FoundationNews/MORAESVkey" />
                    <Link hidden href="/FoundationNews/UFwhitneyLab" />

                    <Link hidden href="/Research/Differencesinvisualperception" />
                    <Link hidden href="/Research/UCFMarineTurtleResearchGroup" />
                    <Link hidden href="/Research/FloridaHawksbillProject2020" />
                    <Link hidden href="/Research/AMDRO" />
                    <Link hidden href="/Research/IdentifyingSexinHatchlingTurtles" />
                    <Link hidden href="/Research/MigrationofLoggerheadHatchlings" />
                    <Link hidden href="/Research/AnimalBehaviorandVisualPerception" />
                    <Link hidden href="/Research/EpibiontsofHawksbill" />
                    <Link hidden href="/Research/StudyingFloridasLivingDinosaurs" />
                    <Link hidden href="/Research/SatelliteTracking" />
                    <Link hidden href="/Research/RecoveryatGumboLimbo" />
                    <Link hidden href="/Research/StudySeaTurtlesinBiscayneNationalPark" />
                    <Link hidden href="/Research/EvaluatingtheEffectsofPaternity" />
                    <Link hidden href="/Research/CanMarineTurtlesNavigate" />
                    <Link hidden href="/Research/OctopusSuperpowers" />
                    <Link hidden href="/Research/SeekingTheGreenTurtles" />
                    <Link hidden href="/Research/HawksbillTurtleAggregation" />
                    <Link hidden href="/Research/Whysexingaseaturtlehatchlingisimportant" />
                    <Link hidden href="/Research/HawksbillProjectHighlightedinVideoProduction" />


                    <Link hidden href="/AdoptSeaTurtle" />

                    <Link hidden href="/WeSupport" />
                    <Link hidden href="/Sponsors" />
                    <Link hidden href="/Contact" />

                  </div>


                  <Switch>
                    <Route exact path="/" component={Home} />
                    <Route exact path="/Education" component={Education} />
                    <Route exact path="/HawksbillProject" component={HawksbillProject} />
                    <Route exact path="/Conservation" component={Conservation} />
                    <Route exact path="/FoundationNews" component={FoundationNews} />
                    <Route exact path="/FoundationNews/LeatherbackSeaTurtleVision" component={LeatherbackSeaTurtleVision} />
                    <Route exact path="/FoundationNews/WaterwayCleanup" component={WaterwayCleanup} />
                    <Route exact path="/FoundationNews/FloridaSeaTurtlesGetaBoost" component={FloridaSeaTurtlesGetaBoost} />
                    <Route exact path="/FoundationNews/SargassumBloomsandHatchlingProduction" component={SargassumBloomsandHatchlingProduction} />
                    <Route exact path="/FoundationNews/AReelDilemma" component={AReelDilemma} />
                    <Route exact path="/FoundationNews/memoryofLlewellynEhrhart" component={memoryofLlewellynEhrhart} />
                    <Route exact path="/FoundationNews/NewAluminumNestMarkingSigns" component={NewAluminumNestMarkingSigns} />
                    <Route exact path="/FoundationNews/SeaTurtleMonitoringandSatelliteTracking" component={SeaTurtleMonitoringandSatelliteTracking} />
                    <Route exact path="/FoundationNews/SeaTurtleAdventures2021" component={SeaTurtleAdventures2021} />
                    <Route exact path="/FoundationNews/StatewideNestingSummary2018" component={StatewideNestingSummary2018} />
                    <Route exact path="/FoundationNews/SeaTurlteAdventures" component={SeaTurtleAdventures} />
                    <Route exact path="/FoundationNews/EducationatFIUCenterOceans" component={EducationatFIUCenterOceans} />
                    <Route exact path="/SeaTurtleFacts" component={SeaTurtleFacts} />
                    <Route exact path="/SeaTurtles/Hawksbill" component={Hawksbill} />
                    <Route exact path="/SeaTurtles/KempsRidley" component={KempsRidley} />
                    <Route exact path="/SeaTurtles/Loggerhead" component={Loggerhead} />
                    <Route exact path="/SeaTurtles/Green" component={Green} />
                    <Route exact path="/SeaTurtles/Leatherback" component={Leatherback} />
                    <Route exact path="/Membership/BecomeAMember" component={BecomeAMember} />
                    <Route exact path="/ScholarshipProgram" component={ScholarshipProgram} />
                    <Route exact path="/CashDonation" component={CashDonation} />

                    {/* <Route exact path="/Component/HawksbillProjectForm" component={HawksbillProjectForm} /> */}
                    <Route exact path="/FoundationNews/DaringExcitingToothy" component={DaringExcitingToothy} />
                    <Route exact path="/FoundationNews/ClassroomEducation" component={ClassroomEducation} />
                    <Route exact path="/FoundationNews/OutandAbout" component={OutandAbout} />
                    <Route exact path="/FoundationNews/NavigatingtheFuture" component={NavigatingtheFuture} />
                    <Route exact path="/FoundationNews/SupportsEducation" component={SupportsEducation} />
                    <Route exact path="/FoundationNews/WhatAreYouDoing" component={WhatAreYouDoing} />
                    <Route exact path="/FoundationNews/MaleGreenTurtles" component={MaleGreenTurtles} />
                    <Route exact path="/FoundationNews/LeatherbackNesting" component={LeatherbackNesting} />
                    <Route exact path="/FoundationNews/SaltyAirSea" component={SaltyAirSea} />
                    <Route exact path="/FoundationNews/SandyPoint" component={SandyPoint} />
                    <Route exact path="/FoundationNews/LearningLeatherbacks" component={LearningLeatherbacks} />
                    <Route exact path="/FoundationNews/FAUsecondYear" component={FAUsecondYear} />
                    <Route exact path="/FoundationNews/NovaMember" component={NovaMember} />
                    <Route exact path="/FoundationNews/SupportFLgulf" component={SupportFLgulf} />
                    <Route exact path="/FoundationNews/GlobalSeaTurtle" component={GlobalSeaTurtle} />
                    <Route exact path="/FoundationNews/TrunksTravelSouth" component={TrunksTravelSouth} />
                    <Route exact path="/FoundationNews/InwaterResearch" component={InwaterResearch} />
                    <Route exact path="/FoundationNews/MEECadds" component={MEECadds} />
                    <Route exact path="/FoundationNews/UCFReceives" component={UCFReceives} />
                    <Route exact path="/FoundationNews/FinalReport2020" component={FinalReport2020} />
                    <Route exact path="/FoundationNews/TemperatureInterview" component={TemperatureInterview} />
                    <Route exact path="/FoundationNews/MarineTurtleHistory" component={MarineTurtleHistory} />
                    <Route exact path="/FoundationNews/MikeSalmon" component={MikeSalmon} />
                    <Route exact path="/FoundationNews/RecipientsChosen" component={RecipientsChosen} />
                    <Route exact path="/FoundationNews/WhitneyLab" component={WhitneyLab} />
                    <Route exact path="/FoundationNews/IndianRiver" component={IndianRiver} />
                    <Route exact path="/FoundationNews/FAUlabRefreshed" component={FAUlabRefreshed} />
                    <Route exact path="/FoundationNews/FGCUawards" component={FGCUawards} />
                    <Route exact path="/FoundationNews/BlackSaltmarsh" component={BlackSaltmarsh} />
                    <Route exact path="/FoundationNews/DrErinSeney" component={DrErinSeney} />
                    <Route exact path="/FoundationNews/NewTurtleModel" component={NewTurtleModel} />
                    <Route exact path="/FoundationNews/UCFscholarshipAward" component={UCFscholarshipAward} />
                    <Route exact path="/FoundationNews/UVIpartnership" component={UVIpartnership} />
                    <Route exact path="/FoundationNews/FLHawkbill2020" component={FLHawkbill2020} />
                    <Route exact path="/FoundationNews/InwaterJupiter" component={InwaterJupiter} />
                    <Route exact path="/FoundationNews/LeatherbackLight" component={LeatherbackLight} />
                    <Route exact path="/FoundationNews/SandyPoint2020" component={SandyPoint2020} />
                    <Route exact path="/FoundationNews/MeetStudents" component={MeetStudents} />
                    <Route exact path="/FoundationNews/AmazingMantas" component={AmazingMantas} />
                    <Route exact path="/FoundationNews/CostalCleanup" component={CostalCleanup} />
                    <Route exact path="/FoundationNews/TurlteAdventureExpand" component={TurlteAdventureExpand} />
                    <Route exact path="/FoundationNews/InsightsKeewaydin" component={InsightsKeewaydin} />
                    <Route exact path="/FoundationNews/EastCoastBiologists" component={EastCoastBiologists} />
                    <Route exact path="/FoundationNews/WarmingOliveRidley" component={WarmingOliveRidley} />
                    <Route exact path="/FoundationNews/SargassoSea" component={SargassoSea} />
                    <Route exact path="/FoundationNews/InsightsKeewaydin2" component={InsightsKeewaydin2} />
                    <Route exact path="/FoundationNews/EducationDuringCOVID" component={EducationDuringCOVID} />
                    <Route exact path="/FoundationNews/SargassumNowWorld" component={SargassumNowWorld} />
                    <Route exact path="/FoundationNews/StcroixProject" component={StcroixProject} />
                    <Route exact path="/FoundationNews/PHDstudents" component={PHDstudents} />
                    <Route exact path="/FoundationNews/HelpedBioAlum" component={HelpedBioAlum} />
                    <Route exact path="/FoundationNews/StyrofoamBoxes" component={StyrofoamBoxes} />
                    <Route exact path="/FoundationNews/BrowardCountryNesting" component={BrowardCountryNesting} />
                    <Route exact path="/FoundationNews/Hawksbill2021" component={Hawksbill2021} />
                    <Route exact path="/FoundationNews/InsideTurtleNest" component={InsideTurtleNest} />
                    <Route exact path="/FoundationNews/InwaterTeachesPasco" component={InwaterTeachesPasco} />
                    <Route exact path="/FoundationNews/MORAESVkey" component={MORAESVkey} />
                    <Route exact path="/FoundationNews/UFwhitneyLab" component={UFwhitneyLab} />
                    <Route exact path="/Research/Differencesinvisualperception" component={Differencesinvisualperception} />
                    <Route exact path="/Research/UCFMarineTurtleResearchGroup" component={UCFMarineTurtleResearchGroup} />
                    <Route exact path="/Research/FloridaHawksbillProject2020" component={FloridaHawksbillProject2020} />
                    <Route exact path="/Research/AMDRO" component={AMDRO} />
                    <Route exact path="/Research/IdentifyingSexinHatchlingTurtles" component={IdentifyingSexinHatchlingTurtles} />
                    <Route exact path="/Research/MigrationofLoggerheadHatchlings" component={MigrationofLoggerheadHatchlings} />
                    <Route exact path="/Research/AnimalBehaviorandVisualPerception" component={AnimalBehaviorandVisualPerception} />
                    <Route exact path="/Research/EpibiontsofHawksbill" component={EpibiontsofHawksbill} />
                    <Route exact path="/Research/StudyingFloridasLivingDinosaurs" component={StudyingFloridasLivingDinosaurs} />
                    <Route exact path="/Research/SatelliteTracking" component={SatelliteTracking} />
                    <Route exact path="/Research/RecoveryatGumboLimbo" component={RecoveryatGumboLimbo} />
                    <Route exact path="/Research/StudySeaTurtlesinBiscayneNationalPark" component={StudySeaTurtlesinBiscayneNationalPark} />
                    <Route exact path="/Research/EvaluatingtheEffectsofPaternity" component={EvaluatingtheEffectsofPaternity} />
                    <Route exact path="/Research/CanMarineTurtlesNavigate" component={CanMarineTurtlesNavigate} />
                    <Route exact path="/Research/OctopusSuperpowers" component={OctopusSuperpowers} />
                    <Route exact path="/Research/SeekingTheGreenTurtles" component={SeekingTheGreenTurtles} />
                    <Route exact path="/Research/HawksbillTurtleAggregation" component={HawksbillTurtleAggregation} />
                    <Route exact path="/Research/Whysexingaseaturtlehatchlingisimportant" component={Whysexingaseaturtlehatchlingisimportant} />
                    <Route exact path="/Research/HawksbillProjectHighlightedinVideoProduction" component={HawksbillProjectHighlightedinVideoProduction} />
                    <Route exact path="/AdoptSeaTurtle" component={AdoptSeaTurtle} />
                    <Route exact path="/WeSupport" component={WeSupport} />
                    <Route exact path="/Sponsors" component={Sponsors} />
                    <Route exact path="/Contact" component={Contact} />

                    <Route path="*" component={NotFoundPage} />
                  </Switch>
                </motion.div>
              </div>
            </Router >

          </HelmetProvider>
        </div >
        <div >
          <SocialMedia />
        </div>
        <div div className="" >
          <Footer />
        </div>
      </div >
    </div >
  );
}

export default App;